<template>
    <div>
        <h6 class="sibebar-title text-left text-black">
            {{ $t('profile-tags') }}
        </h6>
        <base-chips-input
            :value="contactTags"
            :suggestions="tagNames"
            :placeholder="$t('add-tag')"
            :label="$t('profile-tags')"
            @input="updateTags"
        ></base-chips-input>
    </div>
</template>
<script>

// Internal components
import BaseChipsInput from '@/core/components/BaseChipsInput.vue';

// External libraries
const clone = require('rfdc')();
import {
    mapActions,
    mapGetters,
    mapState
} from 'vuex';

export default {
    components: { BaseChipsInput },

    created () {
        this.getTags();
    },

    mounted () {
        this.contactTags = clone(this.singleTags);
    },

    data () {
        return { contactTags: [] };
    },

    computed: {
        ...mapState('core/contacts', {
            contact: 'single'
        }),

        ...mapGetters('core/contacts', {
            singleTags: 'singleTags',
        }),

        ...mapGetters('core/tags', {
            'allTags': 'tags'
        }),

        tagNames () {
            return Object.values(this.allTags || {}).map(tag => tag.attributes.name);
        }
    },

    watch: {
        /**
         * singleTags watcher
         *
         * @param      {Object}  value   The value
         */
        singleTags: function (value) {
            this.contactTags = clone(value);
        }
    },

    methods: {
        ...mapActions('core/contacts', {
            'patchContact': 'patch'
        }),

        ...mapActions('core/tags', {
            getTags: 'index'
        }),

        updateTags (tags) {
            const hasNewTag = tags.some(tag => !this.tagNames.includes(tag));

            this.contactTags = tags;
            this.patchContact({
                id:         this.contact.id,
                attributes: { tags }
            })
                .then(() => {
                    if (hasNewTag) {
                        this.getTags();
                    }
                });
        }
    }
};
</script>
